<template>
    <div class="sammio-statute">
        <h2 class="mb-5">{{ statuteTitle }}</h2>

        <h3 class="mb-5" v-if="(sections.length > 0) && sections[0].parentVisible">{{ getChapterTitle() }} </h3>

        <v-card
                v-for="(section, i) in sections"
                outlined
                flat
                tile
                :key="section.name"
            >
            <v-card-title class="mt-5">
                <h4
                    :id="'section-' + statuteOrdinal + '-' + section.ordinal"
                    @click="$emit('section-title-click', section.ordinal - 1)"
                >
                    {{ getSubSectionName(section) }}
                </h4>
            </v-card-title>
            <v-card-text>
                <div v-for="(subsection, index) in section.subsections" :key="`${subsection.ordinal}-${index}`">
                    <div v-if="(statuteOrdinal === 1) && (section.ordinal === 4)">
                        <div v-html="getRadiationLawFourthSectionHtml(subsection.subsection, index)"></div>
                    </div>
                    <div v-else v-html="subsection.subsection"></div>
                </div>
            </v-card-text>
        </v-card>
    </div>

</template>

<script>

    import {i18n} from "../../translations/i18n";

    export default {
        name: "SammioStatuteChapter",
        data() {
            return {
                initialHtmlLoaded: false
            }
        },
        props: {
            statuteTitle: String,
            statuteOrdinal: Number,
            chapterTitle: String,
            chapterTitleReversed: String,
            sections: Array
        },
        watch: {
            sections(newValue) {
                if (newValue && !this.initialHtmlLoaded) {
                    this.initialHtmlLoaded = true
                    let that = this
                    this.$nextTick( () => {
                        that.$emit('initial-chapter-html-loaded')
                    })
                }
            }
        },
        methods: {
            getRadiationLawFourthSectionHtml(html, index) {
                const prefix = this.$t('sammio.this_law_contains')
                const regex = new RegExp(prefix + '[:\\s]*', 'g')
                html = html.replaceAll(regex, '')
                if (index === 0) {
                    html = `<p>${this.$t('sammio.this_law_contains')}:</p>${html}`
                }
                return html
            },
            getChapterTitle() {
                let title = this.chapterTitle
                if (i18n.locale == "en") {
                    // e.g. "Chapter 1 General provisions"
                    title = this.capitalize(this.chapterTitleReversed);
                }
                return title;
            },
            getSubSectionName(section) {
                let title = section.name;
                if (i18n.locale == "en") {
                    // e.g. Subsection 1
                    title = this.capitalize(section.nameReversed);
                }
                return title;
            },
            capitalize(text) {
                const first = text[0].toUpperCase();
                const rest = text.slice(1);

                return first + rest;
            },
        }
    }
</script>

<style scoped>

</style>
